// export const API_URL = "https://localhost:7187/api/v1"
export const API_URL = "https://bimstravel-001-site1.ptempurl.com/api/v1"
